"use strict";

exports.__esModule = true;
exports.MetricValueAggregateWidget = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _MetricValueAggregateElement = require("./MetricValueAggregateElement");
var _MetricValueAggregateFields = require("./MetricValueAggregateFields");
var _MetricValueAggregateHeader = require("./MetricValueAggregateHeader");
var _MetricValueAggregateThumbnail = require("./MetricValueAggregateThumbnail");
var _widgetGroups = require("../widgetGroups");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var MetricValueAggregateWidget = exports.MetricValueAggregateWidget = {
  name: "MetricValueAggregate",
  label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "MetricValueAggregateWidget.label",
    defaultMessage: "Aggregate Metric Value"
  }),
  icon: "trending-up",
  group: _widgetGroups.METRIC_WIDGET,
  createElement: function createElement(props) {
    return {
      type: "MetricValueAggregate",
      props: Object.assign({
        width: 256,
        height: 64,
        metricName: "utilization",
        aggregationType: "AVERAGE",
        includeDevicesIntoCalculation: true
      }, props),
      children: []
    };
  },
  showInPalette: true,
  isParent: true,
  requiresContexts: [],
  suppliesContexts: [],
  optionalProps: ["fontFamily", "fontSize", "fontWeight", "fontStyle", "textDecoration", "textAlignment", "color", "backgroundColor", "backgroundColorSource"],
  requiresProps: ["x", "y", "width", "height", "metricName"],
  suppliesProps: [],
  propConstraints: {
    width: {
      "default": 256,
      min: 32,
      max: 1024
    },
    height: {
      "default": 64,
      min: 32,
      max: 768
    }
  },
  components: {
    Header: _MetricValueAggregateHeader.MetricValueAggregateHeader,
    Element: _MetricValueAggregateElement.MetricValueAggregateElement,
    Fields: _MetricValueAggregateFields.MetricValueAggregateFields,
    Thumbnail: _MetricValueAggregateThumbnail.MetricValueAggregateThumbnail
  }
};